import MainLayout from '../../../../components/layouts/MainLayout';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import SampleSearch from './components/SampleSearch';
import { sampleSearchThunk, reset } from '../../../../store/search';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { useTranslation } from 'react-i18next';
import { Formatter, Loader, Message, theme } from '@omnigenbiodata/ui';
import { isBusySelector, responseSelector, errorSelector } from '../../../../store/search';
import { useEffect } from 'react';
import { AMGEN_DOT_COLOUR } from '../../../../core/constants/forms.constants';

function SampleSearchScene() {
  const { t } = useTranslation('portal');
  const dispatch = useAppDispatch();
  const isBusy = useAppSelector(isBusySelector);
  const errors = useAppSelector(errorSelector);
  const result = useAppSelector(responseSelector);
  let dotColor = '';
  if (result?.sequencer === 'REGENERON') {
    dotColor = theme.palette.info.main;
  } else if (result?.sequencer === 'AMGEN') {
    dotColor = AMGEN_DOT_COLOUR;
  } else {
    dotColor = theme.palette.grey[600];
  }
  const handleSampleSearch = (values: any) => {
    dispatch(sampleSearchThunk(values));
  };

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  return (
    <MainLayout title={t('search.title')}>
      <Box my={2}>
        <SampleSearch onSearch={handleSampleSearch} orderNo={result?.orderNo} />
      </Box>
      {errors && (
        <Message severity="error" title={t('alerts.searchFailed.title') as string}>
          {errors[0].message}
        </Message>
      )}
      {result && !result.postcode && (
        <Message severity="info" title={t('alerts.noSample.title') as string}>
          {t('alerts.noSample.text')}
        </Message>
      )}
      {result?.postcode && (
        <Paper sx={{ background: 'none', mt: 2 }}>
          <Typography
            component="h2"
            variant="h5"
            paragraph
            align="center"
            sx={{
              pb: 1,
              borderBottom: 1,
              borderColor: theme.palette.primary.lighter,
            }}
          >
            <strong>Order Number {result.orderNo}</strong>
          </Typography>
          <Typography variant="body1" paragraph align="center">
            <strong>{t('forms.status')}:</strong> {result.status}
          </Typography>
          {result.sampleBarcode && (
            <>
              <Typography variant="body1" paragraph align="center">
                <strong>{t('forms.barcode')}:</strong> {result.sampleBarcode}
              </Typography>
              <Typography variant="body1" paragraph align="center">
                <strong>{t('forms.sampleLinkTs')}:</strong>{' '}
                <Formatter input={result.sampleLinkTs} format="friendlyDateTime" />
              </Typography>
            </>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
              <Typography variant="body1">
                <strong>{t('forms.sequencer')}:</strong>
              </Typography>

              {dotColor && (
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: dotColor,
                    border: '1px solid white',
                    marginX: 1,
                  }}
                />
              )}

              <Typography variant="body1">{result.sequencer}</Typography>
            </Box>
          </Box>

          <Typography variant="body1" paragraph align="center">
            <strong>{t('forms.postcode')}:</strong> {result.postcode}
          </Typography>
        </Paper>
      )}
      <Loader isVisible={isBusy} label={t('loaders.search') as string} />
    </MainLayout>
  );
}

export default SampleSearchScene;
